import { CivilLawCostsOfIncomeType } from 'app/constants/civilLawCostsOfIncomeType'

export const getCivilLawCostsOfIncomeTypeName = (
  civilLawCostsOfIncomeType: CivilLawCostsOfIncomeType,
  translate: (string) => string,
): string => {
  const text: string = CivilLawCostsOfIncomeType[civilLawCostsOfIncomeType]
  return translate(`civilLawCostsOfIncomeType.${text}`)
}
